import { FolderOutlined, PlaceOutlined } from '@mui/icons-material'
import { Box, Grid, MenuItem, Typography, useTheme } from '@mui/material'

import useSharedStyles from '../../../utils/shared.styles'
import HighlightText from '../../highlight-text'
import useStyles from '../index.styles'

interface IResultAccountItemProps {
  name: string
  accountNumber: string
  address: string /** Should already be formatted */
  folderType: FolderType
  parentName: string
  isDeactivated: boolean
  searchValue: string
  onClick: () => void
}

const ResultAccountItem = (props: IResultAccountItemProps) => {
  const { name: folderName, accountNumber, address, folderType, parentName, isDeactivated, searchValue, onClick } = props
  const classes = useStyles
  const sharedClasses = useSharedStyles
  const theme = useTheme()

  return (
    <MenuItem onClick={onClick} tabIndex={0} data-testid="search-result-item">
      <Grid
        container={true}
        wrap="nowrap"
        sx={{
          alignItems: 'flex-start',
        }}
      >
        <FolderOutlined sx={classes.searchItemIcon} />
        <Box sx={classes.resultItemTextContainer}>
          <Typography variant="body1" className="fs-exclude" sx={sharedClasses.overflowText}>
            <HighlightText text={folderName} query={searchValue} colorHighlight={true} isDeactivated={isDeactivated} />
            {folderType && (
              <Typography variant="caption" sx={classes.searchItemPrimaryTextCaption}>
                • <HighlightText text={folderType} query={searchValue} colorHighlight={true} />
              </Typography>
            )}
          </Typography>
          <Box sx={sharedClasses.overflowText}>
            {folderType === 'Program' && parentName && (
              <Typography variant="caption" className="fs-exclude" sx={sharedClasses.secondaryText}>
                <HighlightText text={parentName} query={searchValue} colorHighlight={true} />
              </Typography>
            )}
            {folderType === 'Participant' && (
              <>
                {accountNumber && (
                  <Typography variant="caption" className="fs-exclude" sx={sharedClasses.secondaryText}>
                    Acct #<HighlightText text={accountNumber} query={searchValue} colorHighlight={true} />
                  </Typography>
                )}
                {address && (
                  <Typography variant="caption" className="fs-exclude" sx={sharedClasses.secondaryText}>
                    <PlaceOutlined sx={{ ...classes.searchItemSecondaryTextIcon(theme), marginLeft: accountNumber ? 1 : 0 }} />
                    <HighlightText text={address} query={searchValue} colorHighlight={true} />
                  </Typography>
                )}
                {parentName && (
                  <Typography variant="caption" className="fs-exclude" sx={sharedClasses.secondaryText}>
                    {' '}
                    {(accountNumber || address) && '•'} <HighlightText text={parentName} query={searchValue} colorHighlight={true} />
                  </Typography>
                )}
              </>
            )}
          </Box>
        </Box>
      </Grid>
    </MenuItem>
  )
}

export default ResultAccountItem
